import React from 'react';
import { AutoFixProvider } from './context/AutoFixContext';
import { AppShell } from './components/Layout/AppShell';

export default function App() {
  return (
    <AutoFixProvider>
      <AppShell />
    </AutoFixProvider>
  );
}
